import { ChangeEvent } from "react";

export function createChangeNumber(
  set: (n: string | number) => void,
  isFloatAllowed: boolean = false,
): (event: ChangeEvent<HTMLInputElement>) => void {
  return function (event: ChangeEvent<HTMLInputElement>): void {
    const { value } = event.target;

    if (value === "" || value === "-") {
      set(value);
      return;
    }

    if (isFloatAllowed && /^-?\d*\.?\d*$/.test(value)) {
      set(value);
      return;
    }

    const numberValue: number = Number(value);
    if (!Number.isNaN(numberValue)) {
      set(numberValue);
      return;
    }

    set(0);
  };
}

export function createBlurChangeNumber(value: string, set: (n: number) => void): () => void {
  return function (): void {
    if (value === "-" || value === "") {
      set(0);
    }
  };
}
